import { events } from '../names';
import { useSendEvent } from '../useSendEvent';

export const useNavAboutClicked = () =>
	useSendEvent(events.navigation.navLinkAboutClick, undefined, {
		forceSendDemoUser: true,
		includeDemoUserMarker: true,
	});
export const useNavTopGridButtonClicked = () =>
	useSendEvent(events.navigation.navTopGridButtonClicked, undefined, {
		forceSendDemoUser: true,
		includeDemoUserMarker: true,
	});

export const useNavTopChatsButtonClicked = () =>
	useSendEvent(events.navigation.navTopChatsButtonClicked, undefined, {
		forceSendDemoUser: true,
		includeDemoUserMarker: true,
	});

export const useNavTopCreateCharacterButtonClicked = () =>
	useSendEvent(
		events.navigation.navTopCreateCharacterButtonClicked,
		undefined,
		{
			forceSendDemoUser: true,
			includeDemoUserMarker: true,
		}
	);

export const useNavTopCreateImageButtonClicked = () =>
	useSendEvent(events.navigation.navTopCreateImageButtonClicked, undefined, {
		forceSendDemoUser: true,
		includeDemoUserMarker: true,
	});

export const useNavTopCreateVideoButtonClicked = () =>
	useSendEvent(events.navigation.navTopCreateVideoButtonClicked, undefined, {
		forceSendDemoUser: true,
		includeDemoUserMarker: true,
	});

export const useNavTopLoginButtonClicked = () =>
	useSendEvent(events.navigation.navTopLoginButtonClicked, undefined, {
		forceSendDemoUser: true,
		includeDemoUserMarker: true,
	});

export const useNavTopSettingsButtonClicked = () =>
	useSendEvent(events.navigation.navTopSettingsButtonClicked, undefined, {
		forceSendDemoUser: true,
		includeDemoUserMarker: true,
	});

export const useNavTopSignOutButtonClicked = () =>
	useSendEvent(events.navigation.navTopSignOutButtonClicked, undefined, {
		forceSendDemoUser: true,
		includeDemoUserMarker: true,
	});

export const useNavLeftGridButtonClicked = () =>
	useSendEvent(events.navigation.navLeftGridButtonClicked, undefined, {
		forceSendDemoUser: true,
		includeDemoUserMarker: true,
	});

export const useNavLeftChatsButtonClicked = () =>
	useSendEvent(events.navigation.navLeftChatsButtonClicked, undefined, {
		forceSendDemoUser: true,
		includeDemoUserMarker: true,
	});

export const useNavLeftCreateCharacterButtonClicked = () =>
	useSendEvent(
		events.navigation.navLeftCreateCharacterButtonClicked,
		undefined,
		{
			forceSendDemoUser: true,
			includeDemoUserMarker: true,
		}
	);

export const useNavLeftCreateImageButtonClicked = () =>
	useSendEvent(events.navigation.navLeftCreateImageButtonClicked, undefined, {
		forceSendDemoUser: true,
		includeDemoUserMarker: true,
	});

export const useNavLeftCreateVideoButtonClicked = () =>
	useSendEvent(events.navigation.navLeftCreateVideoButtonClicked, undefined, {
		forceSendDemoUser: true,
		includeDemoUserMarker: true,
	});

export const useNavLeftAffiliateButtonClicked = () =>
	useSendEvent(events.navigation.navLeftAffiliateButtonClicked, undefined, {
		forceSendDemoUser: true,
		includeDemoUserMarker: true,
	});

export const useNavLeftPartnershipButtonClicked = () =>
	useSendEvent(events.navigation.navLeftPartnershipButtonClicked, undefined, {
		forceSendDemoUser: true,
		includeDemoUserMarker: true,
	});
